import React from "react";
import { Code } from "./Code";
import { VercelAnalytics } from "./VercelAnalytics";

import Layout from "./Layout";
import { Box, Stack, Heading, Link, Text, themeGet } from "@fuegokit/react";
import { AfArrowRightIcon } from "@fuegokit/fuegoicons-react";
import styled from "styled-components";
// import * as packageJson from '../../../../../package.json'
import * as packageJson from "@fuegokit/react/package.json";

function NewLandingReactPage({ pageContext }) {
  return (
    <Layout pageContext={pageContext} variant="react">
      <Box marginY={8} sx={{ maxWidth: "56ch" }}>
        <Heading as="h1" sx={{ fontSize: 7, marginBottom: 4 }}>
          {pageContext.frontmatter.title}
          <Text sx={{ fontSize: 4, color: "text.subtle", paddingLeft: 1 }}>
            v{packageJson.version}
          </Text>
        </Heading>

        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Stack sx={{ color: "text.subtle", fontSize: 4, lineHeight: "1.4" }}>
            <Text>
              Fuegokit React is an implementation of Appfire's design system in
              React with a{" "}
              <Highlight>
                focus on accessibility and developer experience.
              </Highlight>{" "}
            </Text>

            <Text>
              It provides a collection of reusable React components to build
              websites and user interfaces. Adopting the library enables
              developers to use{" "}
              <Highlight>consistent markup, styles, and behaviors</Highlight>{" "}
              from prototypes to production.
            </Text>
          </Stack>
          <CTAGrid>
            <GetStartedLink href="/react/getting-started/install">
              Get started
              <AfArrowRightIcon />
            </GetStartedLink>
            <CodeWrapper>
              <Code>yarn add @fuegokit/react</Code>
            </CodeWrapper>
          </CTAGrid>
        </Box>
      </Box>
      <VercelAnalytics />
    </Layout>
  );
}

const CodeWrapper = styled(Box)`
  > * {
    margin: 0 !important;
  }
`;

const CTAGrid = styled(Box)`
  display: grid;
  gap: ${themeGet("space.3")};
  align-items: center;
  margin: ${themeGet("space.5")} 0;

  @media (min-width: ${themeGet("breakpoints.1")}) {
    grid-template-columns: 1fr 1fr;
  }
`;

const Highlight = styled(Text)`
  border-radius: ${themeGet("radii.1")};
  background-color: rgba(255, 224, 0, 0.4);
`;

const GetStartedLink = styled(Link)`
  padding: ${themeGet("space.3")} ${themeGet("space.3")};
  border-radius: ${themeGet("radii.1")};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${themeGet("colors.text.inverse")};
  background-color: ${themeGet("colors.background.brand.bold.default")};
  gap: ${themeGet("space.2")};
  font-size: ${themeGet("fontSizes.3")};
  font-weight: ${themeGet("fontWeights.bold")};
  height: 51px;

  svg {
    width: 20px;
    height: auto;
    opacity: 0.5;
    margin-left: ${themeGet("space.2")};
  }
  &:hover {
    background-color: ${themeGet("colors.background.brand.bold.hovered")};
    text-decoration: none;
  }
  &:focus {
    background-color: ${themeGet("colors.background.brand.bold.hovered")};
    color: ${themeGet("colors.text.inverse")};
  }
  &:hover svg {
    opacity: 1;
  }
`;

export default NewLandingReactPage;
